/* Car Events Texas – copy event submissions to a Google Sheet (Apps Script web app) */
(function () {
  'use strict';
  var url = String(window.CET_SHEET || '').trim();
  if (!/^https:\/\/script\.google\.com\/macros\/s\/[\w-]+\/exec$/.test(url)) return;
  var sent = false;
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[data-cet-submit]') || sent) return;
    var hp = form.querySelector('[name="cet_hp"]');
    if (hp && hp.value) return;
    var data = { k: 'cet-2026', page: location.pathname };
    new FormData(form).forEach(function (v, n) {
      var m = /^contact\[(.+)\]$/.exec(n);
      if (m && typeof v === 'string') data[m[1]] = v.slice(0, 2000);
    });
    if (!data['Event name']) return;
    sent = true;
    try {
      var body = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' });
      if (!(navigator.sendBeacon && navigator.sendBeacon(url, body))) fetch(url, { method: 'POST', mode: 'no-cors', body: body, keepalive: true });
    } catch (e) {}
  }, true);
})();
